import React from 'react';

const StatusDisplay = ({ status, value }) => {
  if (status === 'safe') {
    return <span style={{ color: '#52c41a' }}>{value}</span>;
  } else if (status === 'found') {
    return <span style={{ color: '#e63946' }}>{value}</span>;
  } else {
    return <span>{value}</span>;
  }
};

export default StatusDisplay; 